<template>
    <div class="container pb-4" v-show="!hideByAutoSelect">
        <h6 class="font-weight-bold mb-4" v-html="serviceHeader"></h6>
        <div class="row no-gutters">
            <PaymentButtonCard 
                v-for="(service, i) in services" 
                :key="i"
                :index="i"
                :service="service" 
                :serviceLength="services.length"
                :effectiveEntitlements="effectiveEntitlements"
                :bookingState="bookingState"
                :isFreeServiceRemaining="isCheckFreeService ? isFreeServiceRemaining() : null"
                :entitlementGroupSettings="getEntitlementGroup(service.entitlement_setting_id)"
                :selectedServiceId="selectedServiceId"
                @click.native="selectService(i, service)"
                @keyEvent="selectService(i, service)"
            />
            <div v-if="isLoading">{{TEXTS.render(`SELECT_SERVICE_LOADING`)}}</div>
            <div v-if="!isLoading && (!services || services.length == 0)">{{TEXTS.render(`SELECT_SERVICE_NO_SERVICES`)}}</div>
        </div>
    </div>
</template>

<script>
    import ResidentPortalFilter from '../../../../common/utils/ResidentPortalFilter';
    import Service from '../../../../common/utils/Service';
    import DateFormattable from '../../../../common/utils/DateFormattable';
    import PaymentButtonCard from './PaymentButtonCard';
    import Texts from '../../../../common/utils/Texts'
    import helper from '../../../../helper';

    export default {
        data() {
            return{
                hideByAutoSelect : false,
                hasTriggeredAutoSelect : false,
                isLoading: true
            }
        },
        components: {
            PaymentButtonCard
        },
        computed: {
            TEXTS: ()=> Texts,
            bookingState : function(){
                return this.$store.getters.GET_BOOKING_STATE;
            },
            activeAddress : function(){
                return this.$store.getters.GET_BOOKING_STATE.activeAddress;
            },
            isCheckFreeService : function(){
                return this.$store.getters.GET_ACTIVE_MULTIPLE_SERVICE_BOOKING_SETTING.check_free_service || false;
            },
            activeAddressSetting : function(){
                return this.$store.getters.GET_BOOKING_STATE.activeAddressSetting;
            },
            allServices : function(){
                return this.$store.getters.GET_SERVICES.list;
            },
            serviceWordingsList(){
                return this.$store.getters.GET_SERVICE_WORDING.list
            },
            serverDate : function(){
                var serverDate =  new DateFormattable(this.$store.getters.GET_SERVER_DATE.payload);
                return serverDate;
            },
            serverDateString : function(){
                return this.$store.getters.GET_SERVER_DATE.payload
            },
            selectedServiceGroupId : function(){
                var selectedServiceGroup = this.$store.getters.GET_BOOKING_STATE.selectedServiceGroup;
                return selectedServiceGroup != null ? selectedServiceGroup.service_group_id : null;
            },
            selectedServiceGroupName(){
                var selectedServiceGroup = this.$store.getters.GET_BOOKING_STATE.selectedServiceGroup;
                return selectedServiceGroup != null ? selectedServiceGroup.group_name : null;
            },
            selectedService() {
                return this.$store.getters.GET_BOOKING_STATE.selectedService;
            },
            selectedServiceId() {
                return this.selectedService != null ? this.selectedService.service_setting_id : null;
            },
            selectedServiceEntitlementId(){
                var selectedService = this.$store.getters.GET_BOOKING_STATE.selectedService;
                return selectedService != null ? selectedService.entitlement_setting_id : null;
            },
            autoSelectServiceId(){
                /*
                    Stry: [US458] As a CSO, I want the service and beginning terms to be auto selected
                    Date: 2021-02-10
                    Auth: Franco Mapua
                    Desc: Retrieving any auto selection code from the general settings
                */
                var userType = this.$store.getters.GET_PERSONAL_INFO.type;
                if(userType != `cso`){
                    return
                }

                const {is_autoselect_for_cso, autoselect_service_setting_id} = this.$store.getters.GET_ACTIVE_MULTIPLE_SERVICE_BOOKING_SETTING || {}

                if(is_autoselect_for_cso == 1 && autoselect_service_setting_id){
                    return autoselect_service_setting_id
                }
            },
            excludedServicesOfAddressSetting : function(){
                var activeAddressSetting =  this.$store.getters.GET_BOOKING_STATE.activeAddressSetting

                var idArray = []

                if(activeAddressSetting){
                    var excludedServices = activeAddressSetting.service_setting

                    for (let i = 0; i < excludedServices.length; i++) {
                        idArray.push(excludedServices[i].service_setting_id)
                    }
                }
                return idArray
            },
            availableBookingDatesOfAddress : function(){
                return this.$store.getters.GET_AVAILABLE_BOOKING_DATES_OF_ADDRESS.list;
            },
            services : function(){
                var availableServices = this.$store.getters.GET_SERVICES.list;
                
                var availableBookingDatesOfAddress = this.availableBookingDatesOfAddress;
                // Get the Selected Address -- Hard Requirement
                if(!availableServices || !this.activeAddress || !this.selectedServiceGroupId || !this.serverDate || availableBookingDatesOfAddress.length == 0){
                    this.$emit('removeLoader');
                    return;
                }

                // Filter by Address Setting
                var filteredServices = [];
                availableServices.forEach(services =>{
                    var service = new Service(services, this.serverDate, this.$store.getters.GET_SERVER_DATE.payload);
                    service.deriveAvailableBookingDates(this.availableBookingDatesOfAddress);
                    filteredServices.push(service);
                });

                if(this.activeAddressSetting){
                    if(this.activeAddressSetting.is_display == 0 || this.activeAddressSetting.is_display == 2){ // Default to Nothing if Is Display is 0 OR 2; Impossible Scenario
                        this.$emit('removeLoader');
                        return [];
                    }
                    else if(this.excludedServicesOfAddressSetting){ 
                        filteredServices = availableServices.filter(service => {
                            for (let i = 0; i < this.excludedServicesOfAddressSetting.length; i++) {
                                if(this.excludedServicesOfAddressSetting[i] == service.service_setting_id){
                                    return false;
                                }
                            }
                            return true;
                        })
                    }
                }

                // Filter By Service Group
                var filteredServices = filteredServices.filter(service =>{
                    return service.service_group_id == this.selectedServiceGroupId;
                })

                // Filter by User 
                var portalFilter = new ResidentPortalFilter();
                var userType = this.$store.getters.GET_PERSONAL_INFO.type;
                filteredServices = portalFilter.filterCollectionByUserType(filteredServices, userType)
    
                filteredServices.sort((a, b) =>{
                    return a.order - b.order;
                })
                
                // Update Transaction State
                if(this.bookingState.servicesOfServiceGroup != filteredServices){
                    var bookingStateUpdateObject = {};
                    bookingStateUpdateObject.servicesOfServiceGroup = filteredServices;
                    this.$store.dispatch('setBookingState', bookingStateUpdateObject);
                }

                // remove the loader
                this.$emit('removeLoader');
                this.isLoading = false;

                return filteredServices;
            },
            serviceGroupSet() {
                return this.$store.getters.GET_ACTIVE_SERVICE_GROUP;
            },
            effectiveEntitlements(){
                var entitlementSummary = this.bookingState.entitlementSummary;

                if(!entitlementSummary){
                    return {}; // Default to false;
                }

                return entitlementSummary.effectiveEntitlements ? entitlementSummary.effectiveEntitlements : {};
            },
            serviceHeader(){
                var serviceHeader = Texts.render(`SELECT_SERVICE_HEADER`)

                // --- Temporary Hard Coding for the Hills damaged bin request
                if(helper.getPortalName() === "thehills"){
                    var selectedServiceGroupName = this.selectedServiceGroupName
                    if(typeof selectedServiceGroupName == "string"){
                        selectedServiceGroupName = selectedServiceGroupName.toLowerCase()
                    }
                    if(selectedServiceGroupName == "lodge a damaged bin request"){
                        serviceHeader = "Please select main type of damage"
                    }
                }

                return serviceHeader
            }
        },
        mounted(){
            this.$store.dispatch('getServices')
            this.$store.dispatch('getServiceWording')
            this.$store.dispatch('getServerDate', 1);
        },
        methods : {
            selectService(i, service) {
                // If service setting is already selected. Do nothing!
                if (this.$store.getters.GET_ACTIVE_SERVICE_SETTING && this.$store.getters.GET_ACTIVE_SERVICE_SETTING.service_setting_id === service.service_setting_id) {
                    return;
                }

                // Resets the service ID if called without arguments
                if(i == -1){ 
                    service = {};
                }
                if(service && !this.isServiceEntitled(service)){
                    return;
                } else {
                    if(this.bookingState.selectedService != service){
                        var bookingState = this.bookingState;
                        if (this.$store.getters.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED && Object.keys(this.$store.getters.GET_ACTIVE_SERVICE_SETTING).length > 0) {
                            // Check current view selected products && stored multi service booking products
                            if (this.$store.getters.GET_HAS_PARENT_WASTES_SELECTED_AND_EMPTY_CURRENT_SERVICE_WASTES || this.$store.getters.GET_HAS_PARENT_WASTES_SELECTED) {
                                this.$emit('showAlert', this.TEXTS.render(`SERVICE_SWITCH_VALIDATION_INCOMPLETE`, null, { yourItem: `waste type` }));
                                return;
                            }
                            else if (this.$store.getters.GET_HAS_CURRENT_SERVICE_WASTES_AND_EMPTY_CURRENT_SERVICE_DATES) {
                                this.$emit('showAlert', this.TEXTS.render(`SERVICE_SWITCH_VALIDATION_INCOMPLETE`, null, { yourItem: `collection date` }));
                                return;
                            }
                        }

                        // Check if service is Paid and free service still remaining
                        if(this.isCheckFreeService) {
                            const freeService = this.isFreeServiceRemaining();
                            if(service.is_paid == 2 && freeService) {
                                this.$emit('showAlert', this.TEXTS.render(`SERVICE_FREE_STILL_REMAINING`, null, {
                                    serviceName: freeService.service_name
                                }));
                                return;
                            }
                        }
                        
                        // Refresh the available booking dates for slow pcs
                        if(service.deriveAvailableBookingDates == undefined){
                            service = new Service(service, this.serverDate, this.serverDateString)
                        }
                        if(service.deriveAvailableBookingDates !== undefined && !service.availableBookingDates){
                            service.deriveAvailableBookingDates(this.availableBookingDatesOfAddress)
                        }

                        // Get the service wordings if it exists
                        if(this.serviceWordingsList){
                            var wording = this.serviceWordingsList.find(serviceWordingSetting =>{
                                return serviceWordingSetting.service_wordings_service == service.service_setting_id
                            })
                            service.wording = wording
                        } 
                        bookingState.selectedService = service;
                        this.$store.dispatch('setActiveServiceSetting', service);
                        this.$store.dispatch('setBookingState', bookingState);
                        if(bookingState.isAgreedToTerms){
                            this.$emit('nextsection')
                        }
                    }
                }
            },
            isServiceForUserType(service, userType){
                var response = false;
                
                switch(userType){
                    case "cso":
                        response = service.is_cso == 1;
                        break;
                    case "resident":
                        response = service.is_res == 1;
                        break;
                }
                return response;
            },
            getEntitlementGroup(entitlementSettingId){
                var entitlementGroupSettings  = this.$store.getters.GET_ENTITLEMENT_GROUP.list;
                if(!Array.isArray(entitlementGroupSettings)){
                    return null
                }

                return entitlementGroupSettings.find(settings => settings.entitlement_setting_id == entitlementSettingId)
            },
            isServiceEntitled(service) {
                var entitlementSummary = this.bookingState.entitlementSummary;

                if(!service.entitlement_setting_id){
                    return true;
                }
                if(!entitlementSummary){
                    return false; // Default to false;
                }

                // --- Check reference date for subtracting entitlements
                var entitlementGroupSettings = this.getEntitlementGroup(service.entitlement_setting_id)
                var effectiveEntitlements = entitlementSummary.effectiveEntitlements;
                var isServiceEntitled = false;
                // Check if Entitled
                if(!effectiveEntitlements){
                    isServiceEntitled = false
                }
                else if(entitlementGroupSettings && entitlementGroupSettings.entitlement_usage == 2 && (!effectiveEntitlements.current || effectiveEntitlements.current[service.entitlement_setting_id] <= 0)){ // --- If the service group settings is set to reference booking date
                    isServiceEntitled = false
                }
                else if(effectiveEntitlements[service.entitlement_setting_id] && effectiveEntitlements[service.entitlement_setting_id] >= 1){
                    isServiceEntitled = true
                }
                else if(effectiveEntitlements.next && effectiveEntitlements.next[service.entitlement_setting_id] && effectiveEntitlements.next[service.entitlement_setting_id] >= 1){
                    isServiceEntitled = true
                }
                else if(effectiveEntitlements.current && effectiveEntitlements.current[service.entitlement_setting_id] && effectiveEntitlements.current[service.entitlement_setting_id] >= 1){
                    isServiceEntitled = true
                }

                if ( entitlementGroupSettings && entitlementGroupSettings.entitlement_usage == 2 && !isServiceEntitled ) {
                    const { currentPeriod } = entitlementSummary;
                    // Entitlements remaining here does not bound by the current available booking dates returned by API.
                    // It's the actual standing balances of the current address's entitlements based of JDE's record.
                    // We just need to check the Current entitlement balance for `booking date` type service transaction.
                    isServiceEntitled = (currentPeriod && currentPeriod.entitlementsRemaining && currentPeriod.entitlementsRemaining[service.entitlement_setting_id] >= 1);
                }
                
                return isServiceEntitled
            },
            isFreeServiceRemaining() {
                for (let i = 0; i < this.services.length; i++) {
                    if(this.services[i].is_paid == 1 && this.isServiceEntitled(this.services[i])) {
                        return this.services[i];
                    }
                }
                
                return false;
            }
        },
        watch: {
            services() {
                const filteredServices = this.services;
                var self = this
                // Auto Select the service if there's only one available
                if (filteredServices && filteredServices.length == 1 && this.isServiceEntitled(filteredServices[0])) {
                    self.hideByAutoSelect = false;
                    setTimeout(() => {
                        self.selectService(0, filteredServices[0]);
                    }, 500);
                } else if (
                    !this.hasTriggeredAutoSelect &&
                    this.autoSelectServiceId && filteredServices.find(service => service.service_setting_id == this.autoSelectServiceId)
                ) {
                    self.hideByAutoSelect = false;
                    self.hasTriggeredAutoSelect = true;
                    setTimeout(() => {
                        self.selectService(0, filteredServices.find(service => service.service_setting_id == self.autoSelectServiceId));
                    }, 3000);
                } else {
                    this.hideByAutoSelect = false;
                }
            },
            selectedService(val) {
                if(val && this.services && this.services.length == 1 && this.isServiceEntitled(val)) {
                    this.hideByAutoSelect = true;
                } else {
                    this.hideByAutoSelect = false;
                }
            }
        },
    }
</script>